import PropTypes from 'prop-types'
import { HeaderTwo } from 'secondstep-components'
import { CircleImage, StyledContainedButton, Wrapper } from './component.styles'

const K8ProgramPreferencesSetupView = ({
  buttonLabel,
  ftueData,
  header,
  onReadyClick,
}) => {
  // Use the provided header or fall back to default
  const displayHeader =
    header || 'Welcome, click to set up your teaching profile'

  // Use the provided button label or fall back to default
  const displayButtonLabel = buttonLabel || "I'm Ready!"

  // Extract image URL from ftueData
  const imageUrl = ftueData?.content?.image?.url

  return (
    <Wrapper>
      <CircleImage imageUrl={imageUrl} />
      <HeaderTwo dataTestId="header-preferences-setup">
        {displayHeader}
      </HeaderTwo>
      <StyledContainedButton
        dataTestId="preferences-setup-button"
        onClick={onReadyClick}
      >
        {displayButtonLabel}
      </StyledContainedButton>
    </Wrapper>
  )
}

K8ProgramPreferencesSetupView.propTypes = {
  buttonLabel: PropTypes.string,
  ftueData: PropTypes.object,
  header: PropTypes.string,
  onReadyClick: PropTypes.func,
}

export default K8ProgramPreferencesSetupView
